import { render, staticRenderFns } from "./ProductTrial.vue?vue&type=template&id=3be8b17e&scoped=true&"
import script from "./ProductTrial.vue?vue&type=script&lang=js&"
export * from "./ProductTrial.vue?vue&type=script&lang=js&"
import style0 from "./ProductTrial.vue?vue&type=style&index=0&id=3be8b17e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8b17e",
  null
  
)

export default component.exports